import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function RO_FAQ_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='mt-5'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-5'>What is a robot?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          A robot is a programmable machine which is capable of doing complex tasks automatically with precision and efficiency. The robots can be guided by external or internal input to perform any work.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What do you understand by the term, the robotics?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          The robotics is a combined branch of engineering and science which deals with the study of development, operation, and control of intelligent robots. The robotics is a part of Artificial intelligence.
          <br></br><br></br>The robotics technology is used for the development of machines which can perform a complex human task in a very efficient way.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>Which was the first industrial robot?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          The first industrial robot was “Unimate.” It was manufactured by American inventor George Devol in 1950 and used in 1954. It was produced for the transportation of die casting form an assembly line and then welding on auto bodies.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>
  );
}
